export default "__VITE_ASSET__BcxRmMpj__"